<template>
  <div class="team-logo" :class="classes">
    <template v-if="noLogo">
      <div class="team-logo__no-logo">
        <div class="team-logo__no-logo-first">no</div>
        <div>logo</div>
      </div>
    </template>
    <img
      v-else
      class="team-logo__img"
      :src="src"
      :alt="alt"
      @error="error = true"
    />
  </div>
</template>

<script>
export default {
  name: "TeamLogo",
  props: {
    src: String,
    alt: {
      type: String,
      default: ""
    },
    color: {
      type: String
    }
  },
  data: () => ({
    error: false
  }),
  watch: {
    src() {
      this.error = false;
    }
  },
  computed: {
    noLogo() {
      return !this.src || this.error;
    },
    classes() {
      return {
        [`team-logo_${this.color}`]: !!this.color
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".team-logo";

.team-logo {
  width: 160px;
  height: 160px;
  border: 2px solid colors(palette-3);
  border-radius: 4px;
  padding: 4px;
  background-color: colors(palette-2);

  &__img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  &__no-logo {
    width: 100%;
    height: 100%;
    font-size: 40px;
    text-transform: uppercase;
    font-weight: fw(bold);
    background: url("~@/assets/images/teams/team-bg.png") 0 0 no-repeat;
    background-size: cover;
    color: colors(text-3);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    line-height: 1;
  }

  &__no-logo-first {
    font-size: 70px;
  }

  &_second {
    border-color: colors(palette-2);
    background-color: colors(palette-1);
    #{$p}__img {
      background-color: colors(palette-2);
    }
  }

  &_invalid {
    border-color: colors(warning);
    background-color: colors(palette-1);
    #{$p}__img {
      background-color: colors(palette-1);
    }
  }
}
</style>
